import { render, staticRenderFns } from "./singaporeTC.vue?vue&type=template&id=60d5202f&scoped=true&"
import script from "./singaporeTC.vue?vue&type=script&lang=js&"
export * from "./singaporeTC.vue?vue&type=script&lang=js&"
import style0 from "./singaporeTC.vue?vue&type=style&index=0&id=60d5202f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d5202f",
  null
  
)

export default component.exports